import {  useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import { IndicadoresLista } from "../../../../domain/models/indicadores_lista";
import { QualidadeIndicadoresForm, QualidadeIndicadoresSchema } from "../../../schemas/Indicadores/qualidade_indicadores";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";
import PrimaryButton from "../../../../../../common/components/primary_button";

// IndicadoresModal 
 
type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedIdIndicadores: IndicadoresLista | undefined, 
  onClose: () => void;
  onSubmit: (e: QualidadeIndicadoresForm) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void;
};

export const IndicadoresModal = ({
  open, saving,loading, selectedIdIndicadores,
  onClose, onSubmit, onOpenChangeHistory
}: Props) => {

  const hookForm = useForm<QualidadeIndicadoresForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(QualidadeIndicadoresSchema),
  });

  useEffect(() => {
    if(open){
      hookForm.reset();
      if(selectedIdIndicadores){
        let Ativo = selectedIdIndicadores.Ativo === true ? 1 : 0
        hookForm.setValue("Ativo", Ativo);
        if(selectedIdIndicadores.Item) hookForm.setValue("Item", selectedIdIndicadores.Item);
        hookForm.setValue("Descricao", selectedIdIndicadores.Descricao);
        hookForm.setValue("Frequencia", selectedIdIndicadores.Frequencia);
        hookForm.setValue("Indice", selectedIdIndicadores.Indice);
        hookForm.setValue("Meta", selectedIdIndicadores.Meta);
        hookForm.setValue("Resultado", selectedIdIndicadores.Resultado);
      }
    }else{
       hookForm.reset({Ativo: 1});
    }
  },[hookForm, open, selectedIdIndicadores]);

  const handleChangeHistory = useCallback(() => {
      if (selectedIdIndicadores) {
        onOpenChangeHistory(selectedIdIndicadores.IdIndicador, LogTipoTabela.INDICADOR);
      }
    }, [selectedIdIndicadores, onOpenChangeHistory]);
  
  return (
  <Dialog
    open={open}
    maxWidth="lg" 
    fullWidth
    PaperProps={{
      component: 'form',
      onSubmit: hookForm.handleSubmit(onSubmit)
    }}
    sx={{ "& .MuiDialog-paper": { maxWidth: "1200px", width: "100%" } }}
  >
    <DialogTitle>
      Objetivos da Qualidade
    </DialogTitle>

    <DialogContent>
      <FormContainer title={"Cadastrar/Editar Item"} arrangement="fullRow">
        <div className="flex flex-col gap-y-4 w-full pt-2">
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center justify-start py-2">
              <FormRadioGroupInput
                name="Ativo"
                label="Status"
                readOnly={saving}
                options={[
                  { id: 0, label: "Inativo" },
                  { id: 1, label: "Ativo" },
                ]}
                reactHookForm={hookForm}
              />
            </div>   
            <DefaultFormInput
              name='Item'
              label='Item'
              required={true}
              reactHookForm={hookForm}
            />
          </div>

          <div className="w-full">
            <DefaultFormInput
              name='Descricao'
              label='Objetivo'
              multiline={true}
              rows={4}
              reactHookForm={hookForm}
            />
          </div>

          <div className="w-full">
            <DefaultFormInput
              name='Indice'
              label='Indice'
              multiline={true}
              rows={2}
              reactHookForm={hookForm}
            />
          </div>

          <div className="w-full">
            <DefaultFormInput
              name='Frequencia'
              label='Frequência'
              multiline={true}
              rows={2}
              reactHookForm={hookForm}
            />
          </div>

          <div className="w-full">
            <DefaultFormInput
              name='Meta'
              label='Meta'
              multiline={true}
              rows={4}
              reactHookForm={hookForm}
            />
          </div>

          <div className="w-full">
            <DefaultFormInput
              name='Resultado'
              label='Resultado'
              multiline={true}
              rows={4}
              reactHookForm={hookForm}
            />
          </div>

        </div>
      </FormContainer>
    </DialogContent>

    <DialogActions>
      <div className="w-full h-full items-center justify-between flex p-4 gap-4">
        <div>
          {
            isNotNullOrUndefined(selectedIdIndicadores) &&
            <PrimaryButton
              buttonColor="yellow"
              onClick={handleChangeHistory}>
              <span className="text-xs">
                Historico de alterações
              </span>
            </PrimaryButton>
          }
        </div>

        <div className="flex flex-row gap-2">
          <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
            <h1
              className="text-sm text-black dark:text-white"
              onClick={onClose}>
              Cancelar
            </h1>
          </div>

          <div className="w-[120px]">
            {saving ? (
              <PrimaryButton
                buttonColor="primary-green">
                Salvando...
              </PrimaryButton>
            ) : (
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Salvar
              </PrimaryButton>
            )}
          </div>
        </div>
      </div>
    </DialogActions>
  </Dialog>
);
}